<template>
     <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>假期管理->假期规则</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校" @change="getData">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
 
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  icon="el-icon-plus" @click="setAdd()">新增假期</el-button>
                </div> 
            </div>
            <el-table
                :data="data"
                style="width:100%;margin-bottom:20px;"
                row-key="id"
                height="550"
                border
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                default-expand-all>
                <el-table-column type="index" :index="indexMethod" label="序号" width="50px"></el-table-column>
                <el-table-column prop="vacationName" label="假期名称" :show-overflow-tooltip="true" width="150px"></el-table-column>
                <el-table-column prop="" label="请假单位" width="150px">按半天请假</el-table-column>
                <el-table-column prop="leaveDurationType" label="计算请假时长方式" width="180px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.leaveDurationType == 1">
                            按自然日计算
                        </div>
                        <div v-else-if="scope.row.leaveDurationType == 2">
                            按工作日计算
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="余额规则" :show-overflow-tooltip="true" width="150px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.setSwitch">
                            <div v-if="scope.row.grantDate == 11">
                                每年1月1日自动发放，{{scope.row.quotaDays}}天
                            </div>
                        </div>
                        <div v-else>
                            不限制余额
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="适用范围">
                     <template slot-scope="scope">
                        <div v-if="scope.row.userCount == '0'">
                             所有人员
                        </div>
                        <div v-else>
                            {{scope.row.userCount}}个人
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="110px">
                    <template slot-scope="scope">
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button  @click.native.prevent="refresh(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">刷新</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import add from './Add.vue'; 
    import update from './Update.vue'; 

    export default {
        name:"LeaveRules",
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                data:[],
                form:{
                    deptId:""
                },
                depts:[]
            }
        },
        components: {
            add,update
        },
        created:function () {
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.depts=res.data.list;
                       if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getData(){
                this.loading=true;
                let url  = this.staffLeaveRulesListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.data = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            //新增界面
            setAdd(){
                this.addVisible = true;
                this.$nextTick(() => {
                    this.$refs['add'].init(this.form.deptId);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            del(data){
                this.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.staffLeaveRulesRemoveUrl;
                let data = {
                    id:this.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip("删除成功",1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            // 刷新
            refresh(data){
                this.id = data.id;
                this.$commonFn.showConfirm2("对适用范围内的人员更新假期余额，是否继续？",this.refreshSuccess);
            },
            refreshSuccess(){
                let url = this.staffLeaveRulesRefreshUrl;
                let data = {
                    id:this.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/vacation/leaveRules/List.vue